import { Footer } from "@layouts/Footer";
import heroImage from "@assets/images/faq-hero.svg";
import arrowIcon from "@assets/images/Frame-9.svg";
import safeIcon from "@assets/icons/safeIcon.svg";
import { HeroBadge, useFeedbackModal } from "@components/ui";
import { HeroSection } from "../../components";
import { FAQPage as FAQPageLayout } from "@features/general";

export function FAQ() {
  const { openModal } = useFeedbackModal();

  return (
    <FAQPageLayout
      hero={
        <HeroSection
          title="We're Here to Help, 24 Hours a Day"
          description="At Gaz Investment in Oil and Gas Supply L.L.C. (GAZ), our goal is to make every step of your gas experience simple and transparent."
          heroImage={heroImage}
          cta={
            <button
              onClick={() => openModal()}
              className="flex items-center justify-center gap-2.5 py-3 pl-5 pr-2 bg-[#090d2c] rounded-[40px] hover:bg-[#3d405e] transition-colors"
            >
              <span className="text-[16px] md:text-[20px] lg:text-[24px] tracking-[-0.04em] text-white">
                Report an issue
              </span>
              <img
                src={arrowIcon}
                alt=""
                className="w-8 md:w-10 rounded-full"
              />
            </button>
          }
          badge={
            <HeroBadge
              text="Use the self-service tools, browse our FAQs, or contact our support team for immediate help."
              linkText="Report an Emergency Online"
              icon={<img src={safeIcon} alt="" className="w-7 h-7" />}
              onLinkClick={() => openModal("Emergency / Maintenance")}
            />
          }
        />
      }
      footer={<Footer />}
    />
  );
}

export default FAQ;
